import {Box, Typography, Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import cn from "classnames";
import "./InfoBox.css";

const InfoBox = (props) => {
    const {
        title,
        icon,
        onEdit,
        className,
        children,
    } = props;
    const {t} = useTranslation();

    return (
        <Box className={cn("InfoBox", className)}>
            <Box className="InfoBox-header">
                <Box className="InfoBox-title">
                    {icon && <span className="InfoBox-icon">{icon}</span>}
                    <Typography variant="h2" component="span" className="InfoBox-titleText">
                        {title}
                    </Typography>
                </Box>
                {onEdit && (
                    <Button
                        variant="outlined"
                        onClick={onEdit}
                        className="InfoBox-editButton"
                    >
                        {t("button.edit")}
                    </Button>
                )}
            </Box>
            <Box className="InfoBox-content">
                {children}
            </Box>
        </Box>
    );
};

export default InfoBox;
